import { Component, OnInit } from '@angular/core';
import { PageComponent } from '@icc/helpers';
import { _ } from '@icc/configurator/shared';

@Component({
  selector: 'icc-guides-page',
  templateUrl: './guides-page.component.html',
  styleUrls: ['./guides-page.component.scss']
})
export class GuidesPageComponent extends PageComponent implements OnInit {
  public title = _('INTERFACE|Wybierz prowadnicę');

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
